import { Vue, Component, Watch } from 'vue-property-decorator';
import { appModule, IModelOption, ISceneOption, SceneConstType, ISceneMode } from '@/store/modules/ModuleApp';
import { evaluationApplicationModule } from '@/store/modules/ModuleEvaluationApplication';
import serviceCas from '@/service/ServiceCas';

@Component
/**
 * 模式场景基类
 *
 * @export
 * @class LibsModelSceneMixins
 */
export default class LibsModelSceneMixins extends Vue {
	/** QCP场景 */
	public static SCENE_QCP: string = 'QCP-CDP';

	/** IEG场景 */
	public static SCENE_IEG: string = 'MPP-MPP';

	/** IDC场景 */
	public static SCENE_IDC: string = 'IDC-SPP';

	/**
	 * 获取当前模式场景中文描述
	 *
	 * @readonly
	 * @type {string}
	 * @memberOf LibsModelSceneMixins
	 */
	public get sceneDescription(): string {
		return appModule.sceneModelData.getSceneDescription(appModule.sceneMode.scene);
	}

	/**
	 * 当前APP内模式场景数据
	 *
	 * @readonly
	 * @type {*}
	 * @memberOf LibsModelSceneMixins
	 */
	public get sceneData(): any {
		return appModule.sceneMode;
	}

	/** 场景数据更新 */
	@Watch('sceneData', { immediate: true, deep: true })
	public onSceneDataUpdate(newVal: any, oldVal: any): any {
		// console.log('onSceneDataUpdate', newVal);
	}

	/**
	 * 是否为QCP场景
	 *
	 * @returns {boolean}
	 *
	 * @memberOf LibsModelSceneMixins
	 */
	public isSceneQCP(): boolean {
		// console.log('isSceneQCP...0');

		return this.getSceneDataDesc() === LibsModelSceneMixins.SCENE_QCP;
	}

	/**
	 * 是否为IDC场景
	 *
	 * @returns {boolean}
	 *
	 * @memberOf LibsModelSceneMixins
	 */
	public isSceneIDC(): boolean {
		return this.getSceneDataDesc() === LibsModelSceneMixins.SCENE_IDC;
	}

	/**
	 * 是否为IEG场景
	 *
	 * @returns {boolean}
	 *
	 * @memberOf LibsModelSceneMixins
	 */
	public isSceneIEG(): boolean {
		return this.getSceneDataDesc() === LibsModelSceneMixins.SCENE_IEG;
	}

	/**
	 * 获取当前模式场景字符串表达
	 *
	 * @returns {string}
	 *
	 * @memberOf LibsModelSceneMixins
	 */
	public getSceneDataDesc(): string {
		return `${this.sceneData.scene}-${this.sceneData.model}`;
	}

	/**
	 * 获取ds平台值
	 *
	 * @returns {string}
	 *
	 * @memberOf LibsModelSceneMixins
	 */
	public async getSelectItem(): Promise<any> {
		const res = await serviceCas.getSelectItem({ types: 'platform' });
		if (res.code === 0) {
			const platformAValue = res.data.platform;
			const platformList = [];
			for (let i = 0; i < platformAValue.length; i++) {
				const platform = platformAValue[i].value;
				platformList.push(platform);
				evaluationApplicationModule.getPlatFormList(platformList);
			}
		}
	}
}
